/*************************************************************************
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/

/**
 * @packageDocumentation
 * @module metrics
 */

import {Level} from './Level';

/**
 * Defines the attribute of a metric to be logged.
 */
export default interface Metric {
  /**
   * A long integer storage column, e.g. the value when recordType = Counter.
   */
  counter?: number;

  /**
   * An opaque (to Metrics) object for application storage.
   */
  data?: any;

  /**
   * An application-defined event.
   */
  event?: string | string[];

  /**
   * The importance of this metric, e.g. log level.
   */
  level?: Level;

  /**
   * A human-readable message, e.g. console messages.
   */
  message?: string;

  /**
   * The type of this metric record, may be application-specific.
   */
  recordType?: string;
}
